import { motion } from "framer-motion";
import { Leaf, Users, Calendar, Clock, Sparkles, Trees } from "lucide-react";
import { useLanguage } from "@/lib/LanguageContext";

const getUspItems = (t: (key: string) => string) => [
  {
    key: "authentic",
    title: t("uspAuthenticExperiences"),
    description: t("uspAuthenticDescription"),
    icon: Sparkles
  },
  {
    key: "tailor",
    title: t("uspTailorMade"),
    description: t("uspTailorDescription"),
    icon: Calendar
  },
  {
    key: "community",
    title: t("uspCommunityBased"),
    description: t("uspCommunityDescription"),
    icon: Users
  },
  {
    key: "timely",
    title: t("uspTimelyResponse"),
    description: t("uspTimelyDescription"),
    icon: Clock
  },
  {
    key: "flexibility",
    title: t("uspFlexibility"),
    description: t("uspFlexibilityDescription"),
    icon: Leaf
  },
  {
    key: "ecocentric",
    title: t("uspEcocentric"),
    description: t("uspEcocentricDescription"),
    icon: Trees
  }
];

export default function USPSection() {
  const { t } = useLanguage();
  const uspItems = getUspItems(t);
  
  return (
    <section className="relative py-20 overflow-hidden bg-white">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-gray-20">
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `radial-gradient(circle, #333 1px, transparent 2px)`,
            backgroundSize: "20px 20px",
            backgroundRepeat: "repeat"
          }}
        ></div>
      </div>


   
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            WHY CHOOSE US
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto rounded-full"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {uspItems.map((item, index) => (
            <motion.div
              key={item.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center mb-4">
                <div className="p-2 bg-primary/10 rounded-lg">
                  <item.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold ml-3 text-gray-900">
                  {item.title}
                </h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}